import React, {useState, useEffect} from 'react';
import {Container} from 'react-bootstrap';
import {Paper, Stepper, Step, StepLabel, Typography, CircularProgress, Divider, Button} from '@material-ui/core'
import { commerce } from '../../../lib/commerce';
import {Link, useNavigate} from 'react-router-dom';
import AddressForm from '../AddressForm';
import PaymentForm from '../PaymentForm';

const steps = ['Shipping address', 'Payment details'];

const Checkout = ({cart, order, handleCaptureCheckout, error}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [checkoutToken, setCheckoutToken] = useState(null);
  const [shippingData, setShippingData] = useState({})

  const navigate = useNavigate();

  useEffect(()=>{
    const generateToken = async () => {
      try{
        const token = await commerce.checkout.generateToken(cart.id, {type: 'cart'})
        setCheckoutToken(token);
      }catch(error){
        navigate('/');
      }
    }
    generateToken();
  },[cart])

  let Confirmation = () => order.customer ?(
    <>
    <div>
      <h5>Thank you for you purchase, {order.customer.firstname} {order.customer.lastname}</h5>
      <br/>
      <p>Order ref: {order.customer_reference}</p>
      <br/>
      <Link to='/'>
      <Button variant=''>Back to Home</Button>
      </Link>
    </div>
    </>
  ):(
    <div>
      <CircularProgress/>
    </div>
  )

  if(error){
    <>
    <h5>Error: {error}</h5>
    <br/>
      <Link to='/'>
      <Button variant=''>Back to Home</Button>
      </Link>
    </>
  }

  const nextStep = () => setActiveStep((prevActiveStep) => prevActiveStep +1)
  const backStep = () => setActiveStep((prevActiveStep) => prevActiveStep -1)

  const next = (data) => {
    setShippingData(data);
    nextStep();
  }

  const Form = () =>(activeStep === 0
    ? <AddressForm checkoutToken={checkoutToken} next={next}/> 
    : <PaymentForm shippingData={shippingData} checkoutToken={checkoutToken} nextStep={nextStep} backStep={backStep} handleCaptureCheckout={handleCaptureCheckout}/>)

  return (
    <>
    <Container style={{width:'50%'}}>
      <h4 className='mt-4' style={{textAlign:'center'}} >Checkout</h4>
      <Stepper  activeStep={activeStep}>
        {steps.map((step)=>(
          <Step key={step}>
            <StepLabel>{step}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length 
        ? <Confirmation/> 
        : checkoutToken && <Form/>}

    </Container>
    </>
  )
}

export default Checkout